'use strict';

var App = require('app');
var AppState = require('app_state');
var i18n = require('utils/i18n');
var InfoView = require('components/account/views/info_dialog_view');
var Strings = require('utils/strings');

var MenubarView = Marionette.ItemView.extend({
    template: require('components/menubar/templates/menubar'),
    templateAlarms: require('components/menubar/templates/menubar_alarms'),

    maxAlarmCount: 5,
    maxAlarmNum: 999,

    ui: {
        message: '#js-show-message',
        'search-button': '#js-device-search',
        'search-box': '#js-device-search-term',
    },

    events: {
        'click @ui.search-button': 'gotoSearchPage',
        'keypress @ui.search-box': 'gotoSearchPage',
        'click @ui.message': 'showMessageDialog',
        'click .dropdown-toggle.alarms': function (e) {
            this.alarmBlinking = false;
        },
    },

    templateHelpers: function () {
        return {
            status: [
                { class: 'success', status: 'ok', text: i18n.TR('OK') },
                { class: 'warning', status: 'error', text: i18n.TR('Fehler') },
                { class: 'error', status: 'delayed', text: i18n.TR('Nicht erreichbar') },
                { class: 'deactivated', status: 'deactivated', text: i18n.TR('Inaktiv') },
                { class: 'archived', status: 'archived', text: i18n.TR('Archiviert') },
            ],
            profile: [
                {
                    show: this.optionalEntries.addDevice,
                    icon: 'fa fa-plus',
                    class: 'js-add-device',
                    url: '#',
                    text: i18n.TR('Gerät hinzufügen'),
                    hasDevider: true,
                },
                {
                    show: this.optionalEntries.settings,
                    icon: 'fa fa-user',
                    url: '#profile/settings',
                    text: i18n.TR('Profil'),
                },
                {
                    show: true,
                    icon: 'glyphicon glyphicon-log-out',
                    class: 'js-logout',
                    url: '#',
                    text: i18n.TR('Logout'),
                },
            ],
        };
    },

    initialize: function (data) {
        Marionette.ItemView.prototype.initialize.apply(this, arguments);
        this.lastAlarmCount = data.lastAlarmCount;
        this.alarmBlinking = false;
        this.optionalEntries = data.optionalEntries;

        var self = this;
        window.menuBarResizeHandler = function () {
            self.render();
            self.updateStatus();
        };
        window.resizefunc.push('menuBarResizeHandler');
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);
        data.name = AppState.user.attributes.name;
        data.lastAlarmCount = this.lastAlarmCount > 0 ? '' + this.lastAlarmCount : '';
        data.hasMessage = AppState.message !== undefined;
        data.menubar = window.innerWidth < 768 ? 'MOBILE_MENUBAR' : 'DESKTOP_MENUBAR';
        return data;
    },

    onShow: function () {
        var self = this;
        this.updateStatus();
        this.initializeTimer();
        App.reqres.setHandler('devices:status:update', function () {
            self.updateStatus();
        });
    },

    onBeforeDestroy: function () {
        // remove resize handler
        var handlerFuncIndex = window.resizefunc.indexOf('menuBarResizeHandler');
        if (handlerFuncIndex != -1) {
            window.resizefunc.splice(handlerFuncIndex, 1);
            window.menuBarResizeHandler = undefined;
        }
    },

    onRender: function () {
        this.updateBadge();
    },

    initializeTimer: function () {
        var view = this;
        setTimeout(function () {
            if (!view.isDestroyed) {
                if (AppState.availableColumnData('status')) {
                    view.updateStatus();
                }
                view.initializeTimer();
            }
        }, 15 * 1000);
    },

    gotoSearchPage: function (e) {
        if (e.type === 'keypress' && e.which != 13) {
            // only handle [ENTER] key
            return;
        }

        e.preventDefault();

        AppState.clearURLParameterCache();
        App.trigger('device:filter', Strings.searchRequest($('#js-device-search-term').val()));
    },

    updateStatus: function () {
        var view = this;

        var deviceStatus = App.request('devices:status');
        $.when(deviceStatus).done(function (deviceStatus) {
            var summarizedStatus = 'deactivated';
            var status = { ok: 0, error: 0, unreachable: 0, deactivated: 0, archived: 0 };

            if (deviceStatus !== undefined) {
                status = deviceStatus.attributes;

                var nrDevices = status.ok + status.error + status.unreachable;
                if (nrDevices > 0) {
                    summarizedStatus = 'success';
                    if (status.unreachable > 0) {
                        summarizedStatus = 'error';
                    } else if (status.error > 0) {
                        summarizedStatus = 'warning';
                    }
                }
            }
            // update device counts
            $('.js-device-ok').text(status.ok);
            $('.js-device-error').text(status.error);
            $('.js-device-delayed').text(status.unreachable);
            $('.js-device-deactivated').text(status.deactivated);
            $('.js-device-archived').text(status.archived);

            $('#js-device-summary').removeClass('error warning success deactivated').addClass(summarizedStatus);

            // loose the structure
            status.alarmList = [];

            _.each(status.alarms, function (a) {
                status.alarmList.push({
                    triggeredAtStr: new Date(a.triggered_time).toLocaleString(),
                    name: a.name,
                    alarmName: a.alarm_name,
                    deviceName: a.device_name,
                });
            });

            view.lastAlarmCount = status.alarmList.length;
            view.alarmBlinking = status.alarmList.length > 0;

            view.updateBadge();
            if (status.alarmList.length > view.maxAlarmCount) {
                status.alarmShowMore = status.alarmList.length - view.maxAlarmCount;
                status.alarmList = status.alarmList.slice(0, view.maxAlarmCount);
            }

            $('.js-alarm-replace').remove();
            //desktop version only
            $('.js-alarm-top-list').append(view.templateAlarms(status));
            // mobile verison only
            $('#js-alarm-count-badge').text(status.alarmList.length);
            // link events
            view.param = status;
            $('.js-alarm-menu-item').on('click', function (e) {
                e.preventDefault();
                App.trigger('alarm:list:show');
            });
        });
    },

    updateBadge: function () {
        var cnt = this.lastAlarmCount;
        if (cnt > this.maxAlarmNum) {
            cnt = '>' + this.maxAlarmNum;
        }
        $('.js-alarm-count-badge').text(this.lastAlarmCount > 0 ? '' + cnt : '');

        $('#favicon').attr('href', 'theme/images/' + (cnt > 0 ? 'alarm' : 'favicon') + '.ico');

        this.blinkAlarm();
    },

    blinkAlarm: function () {
        if (!this.alarmBlinking || this.alarmBlinkingInitialized) {
            return;
        }
        this.alarmBlinkingInitialized = true;

        var self = this;
        var ctrl = $('.js-alarm-count-badge').closest('a').find('i');

        // make it red
        ctrl.addClass('error');

        setTimeout(function () {
            // make it white
            ctrl.removeClass('error');
            setTimeout(function () {
                self.alarmBlinkingInitialized = false;
                self.blinkAlarm();
            }, 400);
        }, 400);
    },

    showMessageDialog: function (e) {
        App.showModal(
            new InfoView({
                want: {
                    messages: true,
                },
                infos: [
                    {
                        id: 'messages',
                        color: 'danger',
                        title: AppState.message.title,
                        summary: AppState.message.summary,
                        details: AppState.message.details,
                    },
                ],
            })
        );
    },
});

module.exports = MenubarView;
